import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { liveSettingService } from '../../../services/setting'
import { useGlobalStore } from '../../../store/global-store'

export const USER_LIVE_SETTING_QUERY_KEY = 'getUserLiveSetting'

export const useGetUserLiveSetting = () => {
  const liveId = useGlobalStore(useShallow((state) => state?.liveId))

  const queryClient = useQueryClient()

  const { data, isLoading, refetch } = useQuery({
    queryKey: [USER_LIVE_SETTING_QUERY_KEY, { liveId }],
    staleTime: Infinity,
    enabled: Boolean(liveId),
    queryFn: () => {
      return liveSettingService.getUserSetting({ liveId: liveId! })
    },
  })

  const get = useCallback(async () => {
    const response = await queryClient.fetchQuery({
      queryKey: [USER_LIVE_SETTING_QUERY_KEY, { liveId }],
      queryFn: () => {
        return liveSettingService.getUserSetting({ liveId: liveId! })
      },
    })

    return response?.data
  }, [queryClient, liveId])

  return {
    setting: data?.data,
    isLoading,
    refetch,
    get,
  }
}
